import { ChangeDetectorRef, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';
// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';
import { JobViewService } from "@app/features/customers/customer/jobs-view/service/job-view-service";
var AddPartKitModal = /** @class */ (function () {
    function AddPartKitModal(formBuilder, ajsScope, 
    // private httpService: TemplatesConfigService,
    bsModalRef, changeDetector, systemSettingsService, jobViewService) {
        this.formBuilder = formBuilder;
        this.ajsScope = ajsScope;
        this.bsModalRef = bsModalRef;
        this.changeDetector = changeDetector;
        this.systemSettingsService = systemSettingsService;
        this.jobViewService = jobViewService;
        this.title = 'Add part kit';
        this.closeBtnName = 'Cancel';
        this.action = '';
        this.formModel = {
            partName: '',
            quantity: 1,
            partStatus: ''
        };
        this.selectedKitParts = [];
        this.enablePartStatus = 3;
        this.select2PartStatusConfig = {};
        this.partStatus = [];
    }
    AddPartKitModal.prototype.ngOnInit = function () {
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            partName: [this.formModel.partName, Validators.required],
            quantity: [this.formModel.quantity, [Validators.required, Validators.min(1)]]
        });
        if (this.partStatus.length > 0) {
            this.form.addControl('partStatus', new FormControl(this.formModel.partStatus || '', Validators.required));
        }
        this.initSelect2Config();
    };
    AddPartKitModal.prototype.initSelect2Config = function () {
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            minimumInputLength: 2,
            ajax: {
                url: "" + environment.apiHost + environment.apiBasePath + "getPartKitList",
                data: function (searchText, page) {
                    if (!searchText)
                        return false;
                    return { 'q': encodeURIComponent(searchText) };
                },
                results: function (data) {
                    return { results: data || [] };
                }
            }
        };
        this.select2PartStatusConfig = {
            width: '100%',
            placeholder: '-- Select option--',
            data: this.partStatus.map(function (status, index) { return ({
                id: status.text,
                text: status.text
            }); })
        };
    };
    AddPartKitModal.prototype.ngAfterViewInit = function () {
        var _this = this;
        var that = this;
        $('#part-kit').on('change', function (e) {
            that.selectedPartId = $('#part-kit').select2('val');
            if (that.selectedPartId) {
                that.form.get('partName').setValue(that.selectedPartId);
            }
            else {
                that.form.get('partName').setValue('');
            }
            that.form.get('partName').updateValueAndValidity();
            that.setSelectedValue(that.selectedPartId);
        });
        setTimeout(function () {
            _this.saveBtn.nativeElement.focus();
        }, 900);
    };
    Object.defineProperty(AddPartKitModal.prototype, "f", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    AddPartKitModal.prototype.updateTotalParts = function () {
        var multiplier = +this.form.get('quantity').value || 1;
        this.selectedKitParts.forEach(function (part) {
            part.totalQty = part.quantity * multiplier;
        });
    };
    AddPartKitModal.prototype.blockZero = function (event) {
        if (this.form.get('quantity').value == null && event.key === '0') {
            event.preventDefault();
        }
    };
    AddPartKitModal.prototype.save = function () {
        var _this = this;
        if (this.form.invalid)
            return;
        this.action = 'saving';
        var payload = {
            kitId: this.form.get('partName').value,
            setQuantity: this.form.get('quantity').value
        };
        if (this.partStatus.length > 0) {
            payload['partStatus'] = this.form.get('partStatus').value;
        }
        this.jobViewService.savePartKit(this.customerId, this.customerType, this.jobId, payload).subscribe(function (resp) {
            _this.action = '';
            _this.onClose.next(true);
            _this.bsModalRef.hide();
        }, function (error) {
            _this.action = '';
            console.error('Error saving part kit config:', error);
        });
    };
    AddPartKitModal.prototype.setSelectedValue = function ($event) {
        var _this = this;
        if ($event == '') {
            this.form.get('partName').reset();
            this.selectedKitParts = [];
        }
        else {
            this.jobViewService.getPartKitList($event).subscribe(function (data) {
                if (data) {
                    _this.selectedKitParts = data;
                    _this.updateTotalParts();
                }
            });
        }
    };
    return AddPartKitModal;
}());
export { AddPartKitModal };
